<template>
	<div>
		<b-row>
			<b-col cols="12" class="mb-3 mt-3">
				<h4>Attend on site</h4>
			</b-col>

			<b-col cols="12" v-if="taskTypes[0].length == 0">
				<b-col><h5>There are no tasks in this section</h5></b-col>

				<b-col>
					<job-task-empty index="0" type="0" @add="addTask"> </job-task-empty>
				</b-col>
			</b-col>

			<draggable v-model="taskTypes[0]" tag="b-col" handle=".handle" @end="setTaskOrder">
				<div v-for="(assignment, index) in taskTypes[0]" :key="assignment.Id">
					<job-task :assignmentId="assignment.Id" :index="index" type="0" :engineers="engineers" :subMaterials="subMaterials" :creating="creating" @delete="deleteTask" @add="addTask"> </job-task>
				</div>
			</draggable>
		</b-row>

		<b-row>
			<b-col cols="12" class="mb-3 mt-3">
				<h4>In our workshop</h4>
			</b-col>

			<b-col cols="12" v-if="taskTypes[1].length == 0">
				<b-col><h5>There are no tasks in this section</h5></b-col>
				<job-task-empty index="0" type="1" @add="addTask"> </job-task-empty>
			</b-col>

			<draggable v-model="taskTypes[1]" tag="b-col" handle=".handle" @end="setTaskOrder">
				<div v-for="(assignment, index) in taskTypes[1]" :key="assignment.Id">
					<job-task :assignmentId="assignment.Id" :index="index" type="1" :engineers="engineers" :subMaterials="subMaterials" :creating="creating" @delete="deleteTask" @add="addTask"> </job-task>
				</div>
			</draggable>
		</b-row>

		<b-row>
			<b-col cols="12" class="mb-3 mt-3">
				<h4>Return to site</h4>
			</b-col>

			<b-col cols="12" v-if="taskTypes[2].length == 0">
				<b-col><h5>There are no tasks in this section</h5></b-col>
				<job-task-empty index="0" type="2" @add="addTask"> </job-task-empty>
			</b-col>

			<draggable v-model="taskTypes[2]" tag="b-col" handle=".handle" @end="setTaskOrder">
				<div v-for="(assignment, index) in taskTypes[2]" :key="assignment.Id">
					<job-task :assignmentId="assignment.Id" :index="index" type="2" :engineers="engineers" :subMaterials="subMaterials" :creating="creating" @delete="deleteTask" @add="addTask"> </job-task>
				</div>
			</draggable>
		</b-row>

		<b-modal id="sharedModal" ref="sharedModal" :title="modalTitle" hide-footer>
			<add-note v-if="modalContent == 'note'" @addNote="addNote" entityType="Assignment" :entityId="addingNote" />
		</b-modal>
	</div>
</template>

<script>
import AccountService from '@/api-services/account.service';
import MaterialService from '@/api-services/material.service';
import AssignmentService from '@/api-services/assignment.service';
import JobTask from '@/components/job/job-task';
import JobTaskEmpty from '@/components/job/job-task-empty';
import AddNote from '@/components/partials/add-note';
import Draggable from 'vuedraggable';

export default {
	name: 'JobTaskList',

	// things we have inherited from our parent
	props: ['jobId', 'assignments'],

	components: {
		JobTask,
		JobTaskEmpty,
		Draggable,
		AddNote
	},

	created() {
		this.packTasks();

		this.fetchEngineers();

		this.fetchSubMaterials();
	},

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data() {
		return {
			taskTypes: [[], [], []],

			engineers: [],

			subMaterials: [],

			creating: false,

			addingType: null,
			addingNote: null,

			modalContent: null,
			modalTitle: 'Select'
		};
	},

	methods: {
		fetchEngineers() {
			AccountService.getAll()
				.then((response) => {
					this.engineers = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchMaterials() {
			MaterialService.getAll()
				.then((response) => {
					this.materials = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchSubMaterials() {
			MaterialService.getSubMaterial().then((response) => {
				this.subMaterials = response.data;
			});
		},

		packTasks() {
			this.assignments.forEach((assignment) => {
				this.$set(assignment, 'Open', false);
				this.taskTypes[assignment.TaskType].push(assignment);
			});

			this.taskTypes.forEach((tasks) => {
				tasks.sort((a, b) => (a.Order > b.Order ? 1 : b.Order > a.Order ? -1 : 0));
			});
		},

		editSection(section) {
			this[section] = true;
		},

		updateTasks() {
			let cloneBlocks = JSON.parse(JSON.stringify(this.taskTypes));
			let flattened = cloneBlocks.flat(2);
			this.$emit('updateJobTasks', flattened, true);
		},

		deleteTask(taskType, index) {
			// remove from the list, make a single list for the parent to update everything by
			this.$delete(this.taskTypes[taskType], index);

			let cloneBlocks = JSON.parse(JSON.stringify(this.taskTypes));
			let flattened = cloneBlocks.flat(2);

			this.$emit('updateJobTasks', flattened, false);
		},

		addTask(taskType, prevIndex, taskSubType) {
			let taskTitle = 'New task';
			if (taskSubType == 0) {
				taskTitle = 'Check in';
			} else if (taskSubType == 2) {
				taskTitle = 'Check out';
			}

			let newTask = {
				JobId: this.jobId,
				TaskType: taskType,
				TaskSubType: taskSubType,
				Title: taskTitle,
				Hours: 0,
				Scheduled: null,
				Completed: null,
				SignedOff: false,
				Open: false,
				Order: prevIndex + 1
			};

			let vm = this;
			// save to database
			AssignmentService.create(newTask)
				.then((res) => {
					newTask.Id = res.data.Id;

					this.creating = true;

					vm.taskTypes[taskType].splice(prevIndex + 1, 0, newTask);

					this.setTaskOrder();

					this.$nextTick(() => {
						vm.$root.$emit('bv::toggle::collapse', 'collapse-' + taskType + '-' + newTask.Order);

						this.creating = false;
					});
				})

				.catch((error) => {
					this.$emit('handleError', error.response.data);
				});
		},

		setTaskOrder() {
			this.taskTypes.forEach((tasks) => {
				tasks.forEach((task, i) => {
					task.Order = i;
				});
			});

			this.updateTasks();
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/job/job-task-list.vue